import { autoinject } from "aurelia-framework";
import { StandardLoadOptions } from "app/shared/lib/essette-site";
import { Api, apiCall } from 'app/shared/lib/essette-api';
import { IApiQueryResults, IApiActionResults } from 'app/shared/lib/api/api-types';
import * as MCG from 'app/mcg/models/essette-api';

@autoinject
export class CWQIService {

    ////****************** Fields and Properties ************************************////



    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(public api: Api) { }



    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////



    ////****************** Queries **************************************************////
    @apiCall
    public async loadCwqiEpisodeGuidelines(authId: string, options?: StandardLoadOptions, includes: string[] = [], fields: string[] = [], indicationGuidelines: boolean = false): Promise<IApiQueryResults<MCG.CwqiEpisodeGuideline>> {
        const query = this.api.query('mcg/cwqi/episodes/guidelines')
            .applyStandardLoadOptions(options)
            .filterString('authId', authId)
            .include(...includes)
            .field(...fields);

        if(indicationGuidelines) {
            query.filterBoolean('indicationsGuideline', true);
        }

        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////
    @apiCall
    public async insertCwqiEpisodeGuideline(guideline: MCG.CwqiEpisodeGuideline): Promise<IApiActionResults> {
        const action = this.api.action('insert', 'mcg/cwqi/episodes/guidelines/', guideline);

        return await this.api.post(action);
    }

    @apiCall
    public async activateCwqiEpisodeGuideline(guidelineID: string, isActive: boolean): Promise<IApiActionResults> {
        const actionCode = isActive ? 'reactivate' : 'deactivate';
        const action = this.api.action(actionCode, `mcg/cwqi/episodes/guidelines/${guidelineID}`, { isActive: isActive });
        return isActive ? await this.api.post(action) : await this.api.delete(action);
    }


}
